import { captureClientError } from '@/lib/sentry'

const isProduction = (() => {
  if (typeof import.meta !== 'undefined') {
    const env = (import.meta as { env?: { PROD?: boolean; MODE?: string } }).env
    if (env?.PROD === true) return true
    if (env?.MODE === 'production') return true
  }
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'production') {
    return true
  }
  return false
})()

export function logClientError(message: string, ...details: unknown[]) {
  // Forward to Sentry (no-op until a DSN is configured) so production errors are
  // actually visible — previously they were silently dropped in production.
  captureClientError(message, ...details)
  if (isProduction) return
  console.error(message, ...details)
}

export function logClientWarn(message: string, ...details: unknown[]) {
  if (isProduction) return
  console.warn(message, ...details)
}
